import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { PublicSharedService } from './public-shared.services';
import * as _ from "lodash";
import * as moment from 'moment';
import { DialogOKComponent } from '../shared/modals/dialog-ok.component';
import { NbDialogService } from '@nebular/theme';

@Component({
  selector: 'shared-files.component',
  templateUrl: './shared-files.component.html',
  styleUrls: ['./shared-files.component.scss']
})
export class SharedFilesComponent implements OnInit {

  loading: boolean = false;
  loadingMessage: string = 'Retrieving Data...';
  shareId: string;
  files: string[];
  totalSharedFiles: number;
  shareLinkExpired: boolean = false;
  shareLinkInvalid: boolean = false;
  sharedSettings: any;
  requirePassword: boolean = false;
  submitted: boolean = false;
  isLoaded: boolean = true;
  isCaseShare: boolean = null;
  caseDetail: any = null;
  allowDownload: boolean = true;
  isError: boolean = false;
  isSharedDataAvaliableBox: boolean = false;
  shareDescription: string;
  isSharedExpired: boolean = false;
  expiryDate: Date;

  /** Checkbox Control */
  masterSelected:boolean;
  checklist:any;
  checkedList:any;

  // To store all selected checkboxes data
  selectedCheckboxes: string[] = [];
  dataCheckboxList: any[] = [];
  checkAllControl: boolean;

  totalFiles: number;
  fileDownloadSetting: any;
  downloadZipFileSize: string;
  downloadZipToken:string;
  zipFileSizeLimitMessage: string = '';
  fileSizeLimit:Number = 10737418240;
  isMasterFileExistOnStorageServer: boolean = null;
  isPreviewFileExistOnStorageServer: boolean = null;
  validateFiles: any;
  title: string = 'QUICKTEL SHARED FILES';
  token: string;
  messages: any =  {
    no_data: "No shared file data available.",
    expired:"Access denied! Shared file link has expired on",
    error:"Unable to retrieve shared file data! An unexpected error has occurred."
  }
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private toastService: ToastrService,
    private publicSharedService: PublicSharedService,
    private dialogService: NbDialogService,
  ) { 

    if(window.location.href.indexOf('shared-files') > 0) {
      this.title = 'QUICKTEL SHARED FILES';
    }else if(window.location.href.indexOf('shared-folder') > 0) {
      this.title = 'QUICKTEL SHARED FOLDER';
        
      this.messages.no_data = "No shared folder file data available.";
      this.messages.expired = "Access denied! Shared folder link has expired on";
      this.messages.error = "Unable to retrieve shared folder data! An unexpected error has occurred.";
      this.caseDetail = {
        title: 'Shared Folder',
        tag: 'Unclassified',
      }
    }

  }

  LoadData(res){
    this.requirePassword = false;
    this.isSharedDataAvaliableBox = false;
    this.isSharedExpired = false;
    this.expiryDate = res.expired;
    this.isSharedDataAvaliableBox = false;
    this.totalSharedFiles = 0;
    this.dataCheckboxList =null;;
    this.isError = false;
    if(res.status){
      if(window.location.href.indexOf('shared-folder') > 0 && res.share_type != 'folder') {
        this.isError = true;
      }else if(window.location.href.indexOf('shared-files') > 0 && res.share_type != 'files'){
        this.isError = true;
      }
      else{
        this.allowDownload = res.data.allow_download;
        this.totalSharedFiles = res.data.files.length;
        this.dataCheckboxList = res.data.files;
        this.shareDescription = res.data.description;

        if(window.location.href.indexOf('shared-folder') > 0) {
          this.caseDetail = {
            title:  res.data.folder_name,
            tag: res.data.folder_tag,
          }
        }
      }
    }else{
      switch(res.message){
        case "Password required":
          this.requirePassword = true;
        break;
        case "Share not found":
          this.isSharedDataAvaliableBox = true;
        break;
        case "Share expired":
          this.isSharedExpired = true;
          this.expiryDate = res.expiryDate;
        break;
        case "Files not found" : 
          this.isSharedDataAvaliableBox = true;
          this.toastService.error('Unable to retrieve shared file data! An unexpected error has occurred.');
        break;
        case "Folder not found":
          this.isSharedDataAvaliableBox = true;
          this.toastService.error('Unable to retrieve shared folder file data! An unexpected error has occurred.');
        break;
        case "Files not found in the folder":
          this.isSharedDataAvaliableBox = true;
          this.toastService.error('Shared  folder data does not exist in the system.');
        break;
        default:
            this.isError = true;
        break;
      }
    }
  }

  ngOnInit(): void {
     this.activatedRoute.queryParams.subscribe(params => {
            this.token = encodeURIComponent(params['token']);
            this.publicSharedService.GetSharedfile(this.token,this.publicSharedService.passwordForm).subscribe(res => {
              this.LoadData(res);
            });
    });
  }

  get totalSelectedFiles(): number {
    return this.getSelectedCheckboxes().length;
  }

  getFileDownloadSetting() {
    this.publicSharedService.getFileDownloadSetting().subscribe(result => {

      if(result.data.settings) {
        this.downloadZipFileSize = result.data.settings.ZipFileSizeLimit;
        this.zipFileSizeLimitMessage = "Selected file(s) exceeds the maximum file download limit of ["+this.formatBytes(this.downloadZipFileSize,2)+"]!"
      }
    }, error => {
      console.log(error);
    });
  }

  submitPassword(formData:any, isValid:boolean) {

    this.submitted = true;

    if(!isValid) {
      return;
    }

    this.publicSharedService.passwordForm = {
      password: formData.password,
      require_password: true
    }

    this.loading = true;
    this.loadingMessage = "Processing...";
     this.publicSharedService.GetSharedfile(this.token,this.publicSharedService.passwordForm).subscribe(res => { 
      this.loading = false;
      if(res.status){
        this.requirePassword = false;
        this.LoadData(res);
      }else{
        if(res.message == 'Invalid password'){
          this.toastService.error("Incorrect password! Please try again.");
        }else{
           this.toastService.error("Unable to validate password! An unexpected error has occurred.");
        }
      }
    });
  }

  onToggleSelectedChang(checked: any) {
    for (let i = 0; i < this.dataCheckboxList.length; i++) {
      this.dataCheckboxList[i]['isSelected'] = checked;
    }
  }

  onSelectedChang(checked: any, id: any) {

    let idx = this.dataCheckboxList.findIndex(item => item.id === id);
    this.dataCheckboxList[idx]['isSelected'] = checked;

    const verifyCheckAll = this.dataCheckboxList.every(item => item.isSelected === true);

    if(verifyCheckAll) {
      this.checkAllControl = true;
    } else {
      this.checkAllControl = false;
    }

  }

  getSelectedCheckboxes() {
    this.selectedCheckboxes = this.dataCheckboxList.filter(check => check.isSelected);
    return this.selectedCheckboxes;
  }

  onDownloadFile(event: Event, token: string): void {
    event.preventDefault();
    if(token) {
      this.loading = true;
      this.loadingMessage = "Preparing file to download…"; 

      this.publicSharedService.DownloadFileByToken(token).subscribe(res =>{
          this.loading = false;
          console.log(token);
          if(res.status){
            this.publicSharedService.downloadFile(res.url);
            this.toastService.success("File will begin to download shortly...");
          }else{
            switch(res.mesage){
              case "FILENOTEXIST":
              case "FILEIDNOTFOUND":
                this.toastService.error("Unable to download file! Unable to locate file in the system storage.");
              break;
              default:
                this.toastService.error("Unable to download file! An unexpected error has occurred.");
              break;
            }
          }
      });
    } else {
      this.toastService.error("Unable to download file! An unexpected error has occurred.");
      return;
    }
  }

  onDownloadAll(): void {

    let selectedFiles = this.dataCheckboxList.filter(row => row.isSelected).map(sharedfile => sharedfile.id);
    let sharedfiles = this.dataCheckboxList.filter(row => row.isSelected);
    let totalFilesSize = _.sumBy(sharedfiles, (file: any) => parseInt(file.fileSize));

      if (totalFilesSize > this.fileSizeLimit) {

          var modalData = {
              title:  "File Download",
              body: this.formatBytes(this.fileSizeLimit,2)
          }
        this.dialogService.open(DialogOKComponent, {
          closeOnBackdropClick: false,
          context: modalData
        });
        return;

      }

      this.loading = true;
      this.loadingMessage = "Preparing file to download…"; 

      this.publicSharedService.PrepareDownloadFiles(this.token,{fileIds: selectedFiles}).subscribe(res=>{
        this.loading = false;
        if(res.status){
            this.publicSharedService.DownloadFiles(res.token);
            this.toastService.success('File will begin to download shortly...');
        }else{
            switch(res.message){
                case 'FILEIDNOTFOUND':
                    this.toastService.error('File download failed! Unable to locate file in the system storage.');
                    break;
                case 'FILENOTEXIST': 
                    this.toastService.error('File download failed! Unable to locate file in the system storage.');
                    break;
                default:
                    this.toastService.error('Unable to download selected file(s)! An unexpected error has occurred.');
                    break;
            }
        }
      });
  }

  formatBytes(bytes, decimals) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1000;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  private downloadFile(fileUrl: string) {
    let link = document.createElement("a");
    link.setAttribute("href", fileUrl);
    link.style.display = "none";
    document.body.appendChild(link);
    link.click();
    window.URL.revokeObjectURL(fileUrl);
    document.body.removeChild(link);
  }

  private previewFile(objFile){

    this.publicSharedService.fileType = objFile.file_type;
    this.publicSharedService.previewToken = objFile.prev_token;

    this.router.navigate(['/public-shared/file-preview']);

  }
}
